import React, { useState } from "react";
import { Grid, Typography, Dialog, Box, LinearProgress } from "@mui/material";
import { trackEvent } from "src/Amplitude";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { CustomInput } from "../security/CustomInputField";
import { SubmitButton } from "src/components/forms/SubmitButton";
import { SmsStyles } from "../security/styles/smsStyles";
import api from "src/store/features/api";

export interface SimpleDialogProps {
  open: boolean;
  deactivateTwoFaSelectedValue: string;
  onClose: (value: string) => void;
}

export function DeactivationDialog(props: SimpleDialogProps) {
  const { onClose, deactivateTwoFaSelectedValue, open } = props;
  const classes = SmsStyles();
  const onlyNumbers = /^\d+$/;
  const warningMessage = "Enter the code from your Authenticator app below.";
  const [showProgress, setShowProgress] = useState(false);
  const [error, setError] = useState("");
  const [deactivateTwoFa] = api.useDeactivate2FaMutation();
  const { refetch } = api.useGetUserDatav2Query();

  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .min(6)
      .max(6)
      .matches(
        // eslint-disable-next-line no-useless-escape
        onlyNumbers,
        "Should only contain numbers",
      )
      .required("Verification code is required"),
  });

  const handleClose = () => {
    onClose(deactivateTwoFaSelectedValue);
  };

  const handleSubmitt = async (values: { code: string }) => {
    setShowProgress(true);
    deactivateTwoFa({ twoFactorDto: { code: values.code } })
      .unwrap()
      .then(() => {
        trackEvent("2FA Successfully", {
          option: "Deactivated",
        });
        setShowProgress(false);
        handleClose();
      })
      .catch(() => {
        setShowProgress(false);
        setError("Invalid code, please try again");
      })
      .finally(() => refetch());
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <Grid container className={classes.container}>
        <Formik
          initialValues={{ code: "" }}
          onSubmit={handleSubmitt}
          validationSchema={validationSchema}>
          <Form>
            <Grid container>
              <Grid item xs={12} mt={2}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#FC4c4c",
                  }}>
                  Deactivate Two factor
                </Typography>
                <Typography className={classes.fieldDescription}>{warningMessage}</Typography>
              </Grid>
            </Grid>
            <Field
              fullWidth
              as={CustomInput}
              name="code"
              height="10px"
              size={"small"}
              placeholder="Enter code"
              mb={4}
              error={error}
              setError={setError}
            />
            <SubmitButton
              fullWidth
              sx={{
                height: "45px",
                marginTop: "8px",
                fontWeight: "bold",
                borderRadius: "12px",
              }}>
              <Typography
                fontWeight={"700"}
                color={"#FFF"}
                fontSize="16px"
                textTransform={"capitalize"}>
                Confirm
              </Typography>
            </SubmitButton>
            {showProgress && (
              <Box py={2}>
                <LinearProgress />
              </Box>
            )}
          </Form>
        </Formik>
      </Grid>
    </Dialog>
  );
}
